import React, { ChangeEvent, KeyboardEventHandler, RefObject } from 'react';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';
import { helper_ani } from 'styles/ani';

interface ILoginInput {
	input_id: string;
	type?: 'text' | 'password';
	_placeholder?: string;
	_onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
	_onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
	_ref?: RefObject<HTMLInputElement>;
	_value?: string;
	is_error?: boolean;
	helper?: string;
	_width?: string;
	_margin?: string;
}

const LoginInput = ({
	input_id,
	type = 'text',
	_placeholder,
	_onChange,
	_onKeyDown,
	_ref,
	_value,
	is_error,
	helper,
	_width = '100%',
	_margin,
}: ILoginInput) => {
	return (
		<InputWrapper _width={_width} _margin={_margin} onClick={(e) => e.stopPropagation()}>
			<InputBox
				type={type}
				placeholder={_placeholder}
				id={input_id}
				onChange={_onChange}
				onKeyDown={_onKeyDown}
				ref={_ref}
				value={_value}
				is_error={is_error}
			/>
			<AnimatePresence>
				{helper && helper !== '' && (
					<HelperText
						is_error={is_error ? 'true' : 'false'}
						variants={helper_ani}
						initial="init"
						animate="ani"
						exit="exit"
					>
						{helper}
					</HelperText>
				)}
			</AnimatePresence>
		</InputWrapper>
	);
};

export const InputWrapper = styled.div<{ _width?: string; _margin?: string }>`
	width: ${({ _width }) => _width};
	${({ _margin }) => _margin && `margin: ${_margin}`}
`;

const InputBox = styled.input<{ is_error?: boolean }>`
	width: 100%;
	height: 52px;
	padding: 14px 0;

	${({ theme }) => theme.revised_typo.typo_16m};
	color: ${({ theme }) => theme.colors.revised.dark_blue};
	background-color: transparent;
	border-bottom: 1px solid rgba(27, 41, 80, 0.2);
	outline: none;

	&::placeholder {
		${({ theme }) => theme.revised_typo.typo_16m};
		color: rgba(27, 41, 80, 0.2);
	}

	${({ is_error, theme }) => is_error && `border-color: ${theme.colors.system.red}`}
`;

export const HelperText = styled(motion.div)<{ is_error: 'true' | 'false' }>`
	color: ${(props) => props.theme.colors.gray.gray80_text};
	${({ theme }) => theme.typo.body.span};

	${({ theme, is_error }) =>
		is_error === 'true' &&
		`color: ${theme.colors.system.red_lighten}; font-weight: ${theme.font.weight.bold};`}
`;

export default LoginInput;
